import { createAsyncThunk } from '@reduxjs/toolkit';

import ApiClient from 'api/axiosClient';

export const getServices = createAsyncThunk('services/get', async (_, { rejectWithValue }) => {
  try {
    const data = await ApiClient.get('/services');
    return data;
  } catch (error) {
    if (error.response && error.response.data.message) {
      return rejectWithValue(error.response.data.message);
    } else {
      return rejectWithValue(error.message);
    }
  }
});

export const getSubServices = createAsyncThunk(
  'services/get/sub-services',
  async (serviceId, { rejectWithValue }) => {
    try {
      const data = await ApiClient.get(`/services/${serviceId}/sub-services`);
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getReasons = createAsyncThunk(
  'services/get/reasons',
  async (subServiceId, { rejectWithValue }) => {
    try {
      const data = await ApiClient.get(`/services/sub-services/${subServiceId}/reasons`);
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
